import { genericErrorHandler } from 'lib/Errors';

export const handleCreateChannel =
  ({ dataProvider, appId, clientId, close, setLoading, refresh, notify }) =>
  async (formData) => {
    setLoading(true);

    try {
      const { name, channelType, primary } = formData;
      await dataProvider.create('channels', {
        data: { name, appId, clientId, channelType, primary },
      });
      if (refresh) {
        refresh();
      }
    } catch (err) {
      genericErrorHandler(notify)(err);
    } finally {
      setLoading(false);
      close();
    }
  };
